import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "myCenter"
  }, [_c('Header'), _c('div', {
    staticClass: "usercont content"
  }, [_c('NavMenu'), _c('div', {
    ref: "menucont",
    staticClass: "menucont"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("您当前的位置：")]), _c('span', {
    staticClass: "back-user",
    on: {
      "click": function click($event) {
        return _vm.$router.push('/user');
      }
    }
  }, [_vm._v("个人中心")]), _c('span', {
    staticClass: "slash"
  }, [_vm._v("/")]), !_vm.showRule ? _c('span', {
    staticClass: "my-level"
  }, [_vm._v("我的等级")]) : _c('span', [_c('span', {
    staticClass: "back-user",
    on: {
      "click": function click($event) {
        _vm.showRule = false;
      }
    }
  }, [_vm._v("我的等级")]), _c('span', {
    staticClass: "slash"
  }, [_vm._v("/")]), _c('span', {
    staticClass: "my-level"
  }, [_vm._v("规则说明")])])]), !_vm.showRule ? _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-title"
  }, [_c('h2', {
    staticClass: "title-label"
  }, [_vm._v("我的等级")]), _c('span', {
    on: {
      "click": function click($event) {
        _vm.showRule = true;
      }
    }
  }, [_vm._v("规则说明"), _c('i', {
    staticClass: "iconfont icongengduoxiangqing-copy"
  })])]), _c('div', {
    staticClass: "content-level"
  }, [_c('div', {
    staticClass: "level-list"
  }, _vm._l(_vm.nextLevelList, function (item, index) {
    return _c('span', {
      key: index,
      class: {
        active: _vm.activeIndex === index
      },
      on: {
        "click": function click($event) {
          return _vm.changeActiveIndex(index);
        }
      }
    }, [_vm._v(" LV." + _vm._s(item.level) + _vm._s(index === 0 ? '（当前等级）' : '') + " ")]);
  }), 0), _c('div', {
    staticClass: "list-info"
  }, [_vm.activeIndex === 0 ? _c('div', [_vm.data.userinfolist.headImgUrl !== null ? _c('img', {
    attrs: {
      "src": _vm.data.userinfolist.headImgUrl
    }
  }) : _c('img', {
    attrs: {
      "src": require("@/assets/images/headimg.png")
    }
  })]) : _c('div', {
    staticClass: "head-icon"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/grade_lock.png")
    }
  })]), _c('div', {
    staticClass: "info-item"
  }, [_vm.activeIndex === 0 ? _c('p', {
    staticClass: "nick-name"
  }, [_vm._v(_vm._s(_vm.data.userinfolist.nickName))]) : _c('p', {
    staticClass: "nick-name"
  }, [_vm._v("未解锁")]), _c('div', {
    staticClass: "info-details"
  }, [_c('div', [_vm._v(" 等级权益 "), _vm.nextLevelList.length > 0 ? _c('span', {
    staticClass: "equity-num"
  }, [_vm._v(_vm._s(_vm.nextLevelList[_vm.activeIndex].num.length))]) : _vm._e(), _vm._v("项 ")]), _vm.activeIndex === 0 ? _c('div', {
    staticClass: "current-level"
  }, [_vm.nextLevelList.length > 0 ? _c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "bar-1",
    style: {
      width: _vm.gradeData.growthValue / (_vm.nextLevelList[_vm.activeIndex].nextGrowthValue ? _vm.nextLevelList[_vm.activeIndex].nextGrowthValue : _vm.gradeData.growthValue) * 100 + '%'
    }
  }), _c('div', {
    staticClass: "bar-2",
    style: {
      width: 100 - _vm.gradeData.growthValue / (_vm.nextLevelList[_vm.activeIndex].nextGrowthValue ? _vm.nextLevelList[_vm.activeIndex].nextGrowthValue : _vm.gradeData.growthValue) * 100 + '%'
    }
  })]) : _vm._e(), _vm.nextLevelList.length > 0 ? _c('span', {
    staticClass: "schedule"
  }, [_vm._v("(" + _vm._s(_vm.gradeData.growthValue) + " / " + _vm._s(_vm.nextLevelList[0].nextGrowthValue) + ")")]) : _vm._e()]) : _c('div', {
    staticClass: "growth-value"
  }, [_vm._v(" 需要成长值"), _c('span', [_vm._v(_vm._s(_vm.nextLevelList[_vm.activeIndex].growthValue))])])])])]), _c('div', {
    staticClass: "equity"
  }, [_c('h2', [_vm._v("我的权益")]), _c('div', {
    staticClass: "equity-list"
  }, [_vm.moreEquity && _vm.equityList.length === 0 ? _c('div', {
    staticClass: "more-equity"
  }, [_vm._v(" 升级可享受更多权益哦 ")]) : _vm._e(), _vm._l(_vm.equityList, function (item) {
    return _c('div', {
      key: item.name,
      staticClass: "item-list"
    }, [_c('p', [_c('i', {
      staticClass: "iconfont",
      class: item.icon
    })]), item.code === 1 || item.code === 2 || item.code === 6 || item.code === 7 ? _c('div', [item.code === 1 ? _c('span', {
      staticClass: "desc-1"
    }, [_vm._v(_vm._s(item.name + _vm.nextLevelList[_vm.activeIndex].hardwareDiscount + '折'))]) : _vm._e(), item.code === 2 ? _c('span', {
      staticClass: "desc-1"
    }, [_vm._v(_vm._s(item.name + _vm.nextLevelList[_vm.activeIndex].softwareDiscount + '折'))]) : _vm._e(), item.code === 6 ? _c('span', {
      staticClass: "desc-1"
    }, [_vm._v(_vm._s(_vm.nextLevelList[_vm.activeIndex].noReasonRefundDays + item.name))]) : _vm._e(), item.code === 7 ? _c('span', {
      staticClass: "desc-1"
    }, [_vm._v(_vm._s(_vm.nextLevelList[_vm.activeIndex].noReasonExchangeDays + item.name))]) : _vm._e()]) : _c('div', [_c('span', {
      staticClass: "desc-1"
    }, [_vm._v(_vm._s(item.name))])]), item.code === 1 || item.code === 2 || item.code === 3 ? _c('div', {
      staticClass: "part"
    }, [_vm._v(" 部分 ")]) : _vm._e(), item.code !== 9 ? _c('p', {
      staticClass: "desc-2"
    }, [_vm._v(" " + _vm._s(_vm.nextLevelList[_vm.activeIndex].growthValue) + "成长值 ")]) : _c('p', {
      staticClass: "desc-2"
    }, [_vm._v(" 赠送" + _vm._s(_vm.nextLevelList[_vm.activeIndex].growthIntegral) + "倍积分 ")])]);
  })], 2)])])])]) : _c('div', [_c('grade-rule', {
    attrs: {
      "levelList": _vm.gradeData.levelList ? _vm.gradeData.levelList : [],
      "growthRuleList": _vm.gradeData.growthRuleList ? _vm.gradeData.growthRuleList : []
    }
  })], 1)])], 1), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };